import { Box, Text } from '@jfs/ui-new'
import { useMemo } from 'react'
import ReactDOM from 'react-dom'
import { Dimensions } from 'react-native'

const ToolTipView = ({ visible, top, left }: any) => {
  const isLargeScreen = useMemo(() => Dimensions.get('window').width > 550, [])
  return (
    <>
      {visible ? (
        <Box
          borderRadius={'5px'}
          width={'175px'}
          p={'LARGE'}
          position={'absolute'}
          zIndex={1}
          left={isLargeScreen && left === -1 ? 108 : left - 92}
          top={isLargeScreen && left === -1? 80: top -220}
          backgroundColor={'BLACK'}>
          <Text color={'BG_PRIMARY'} fontFamily="jioType-Medium">
            {
              'We use world class encryption techniques to ensure that your data is safe & secure at all times. Our systems are PCI DSS security certified & adhere to the highest security standards.'
            }
          </Text>
          <Box
            width="0"
            height="0"
            position={'absolute'}
            bottom="-10"
            left={70}
            borderWidth={20}
            borderBottomWidth={0}
            borderLeftColor="TRANSPARENT"
            borderRightColor="TRANSPARENT"
            borderTopColor="BLACK"
          />
        </Box>
      ) : null}
    </>
  )
}

interface props { 
  visible: boolean
  tooltipLeft: number
  tooltipTop: number
}
const UPIToolTip = ({ visible, tooltipLeft, tooltipTop }: props) => {
  const rootView: any = document.getElementById('approot')
  return ReactDOM.createPortal(<ToolTipView visible={visible} top={tooltipTop} left={tooltipLeft}/>, rootView || document.body)
}

export { UPIToolTip }
